import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class WebhooksService {

  constructor(private globalService: GlobalService) {}

  getAll(): Observable<any> {
    return this.globalService.get('/SP-GetAllWebhooks/');
  }

  add(data: any): Observable<any> {
    return this.globalService.post('/SP-AddWebhook/', data);
  }

  update(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateWebhook/', data);
  }

  delete(data: any): Observable<any> {
    return this.globalService.post('/SP-DeleteWebhook/', data);
  }
}

